import React from "react";
import { Heading, If, makeClassName, Modal, ModalProps, Row, toLocalDateString } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { Student } from "../../../../Utilities";
import { PaymentForm } from "../../../Forms";
import { PaymentCreateModalController } from "../../Payment";
import { ContractInstallmentsList, ContractInstallmentsListProps } from "../List";
import styles from "./styles.module.css";

export type ContractInstallmentsListModalProps = {
	title?: string;
	studentID?: Student["id"];
	noPaymentCreate?: boolean;
} & Omit<ContractInstallmentsListProps, "className" | "style"> &
	Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function ContractInstallmentsListModal({
	variant,
	title = "Payment Installments",
	studentID,
	noPaymentCreate,
	ifRef,
	onClose,
	className,
	style,
	contractInstallments,
	...props
}: ContractInstallmentsListModalProps) {
	const paymentCreateFormStateArgs = React.useMemo<PaymentForm.ControlledCreateProps["formStateArgs"]>(() => {
		return {
			initialFormValues: {
				issueDate: toLocalDateString(new Date()),
			},
		};
	}, []);

	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>
					{title} ({contractInstallments.length})
				</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<ContractInstallmentsList variant={variant} contractInstallments={contractInstallments} {...props} />
			</Modal.Body>
			{!!studentID && (
				<If condition={variant === "admin" && contractInstallments.length > 0 && !noPaymentCreate}>
					<Modal.Footer className={styles["modal__footer"]}>
						<Row justify="flex-end">
							<PaymentCreateModalController
								variant="primary"
								studentID={studentID}
								formStateArgs={paymentCreateFormStateArgs}
							>
								<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
									<Icon.PlusCircle size={16} /> Record Payment
								</Row>
							</PaymentCreateModalController>
						</Row>
					</Modal.Footer>
				</If>
			)}
		</Modal>
	);
}
